import { FASTElement } from "@microsoft/fast-element";
/**
 * CardFooter
 * @summary A CardFooter component for use within a card, providing slots for content and actions.
 *
 * @example
 * ```html
 * <fabric-card-footer>
 *   <div>Footer Content</div>
 *   <div slot="action">
 *     <fabric-button>Action 1</fabric-button>
 *     <fabric-button>Action 2</fabric-button>
 *   </div>
 * </fabric-card-footer>
 * ```
 *
 * @slot default - Default slot for footer content.
 * @slot action - Slot for footer action elements, such as buttons or links.
 *
 * @csspart content - The content area of the footer.
 * @cssprop --card-size - Controls the card sizing token used by the footer.
 *
 * @extends FASTElement
 * @tagname fabric-card-footer
 * @public
 */
export class CardFooter extends FASTElement {
}
//# sourceMappingURL=card-footer.js.map